import { Suspense, useEffect } from 'react';
import { Provider } from 'react-redux';
import Router from './_router';
import store from './_services/Redux/store';
import './App.scss';

import Loader from '_atoms/Loader';
import './_i18n';

import * as Sentry from '@sentry/react';
import { captureLandingTouch } from '_services/MarketingTouch';
import { sentryUrl } from '_services/Sentry/Sentry';
import ReactGA from 'react-ga';
import { BrowserRouter } from 'react-router-dom';

const googleTrackingId = process.env.REACT_APP_GA_ID;
if (googleTrackingId) {
    ReactGA.initialize(googleTrackingId);
    ReactGA.pageview(location.pathname + location.search);
}

/**
 * Prevent default browser scrollRestoration from doing it,
 * since it isn't working as it should anyway in SPA's
 */
window.history.scrollRestoration = 'manual';

const App = (): React.JSX.Element => {
    useEffect(() => {
        captureLandingTouch();
    }, []);

    return (
        <Suspense fallback={<Loader />}>
            <>
                <Provider store={store}>
                    <BrowserRouter>
                        <Router />
                    </BrowserRouter>
                </Provider>
            </>
        </Suspense>
    );
};

export default sentryUrl ? Sentry.withProfiler(App) : App;
